<template>
  <ValidationObserver
    ref="observer"
    tag="form">
    <LabelText label-for="最終目標">
      最終目標
    </LabelText>
    <InputContainer>
      <template #prepend>
        <ChangedBox
          :active="hasFinalGoalChanged" />
      </template>
      <BaseTextareaWithProvider
        v-if="isEditable"
        v-model="form.finalGoal"
        field-class="pl-4 font-weight-bold"
        name="最終目標"
        :response-errors="responseErrors"
        rules="required"
        vid="finalGoal" />
      <DisplayFormFIeld
        v-else
        font-size="nm"
        bold
        border>
        {{ form.finalGoal }}
      </DisplayFormFIeld>
    </InputContainer>
    <LabelText label-for="最終目標達成日">
      最終目標達成日
    </LabelText>
    <BaseTextFieldWithProvider
      v-if="isEditable"
      v-model="form.targetDate"
      name="最終目標達成日"
      :response-errors="responseErrors"
      rules="required"
      vid="targetDate"
      type="date"
      col="6" />
    <DisplayFormFIeld
      v-else
      border
      class="pl-2"
      col="6">
      {{ form.targetDate | prettyDate }}
    </DisplayFormFIeld>

    <LabelText label-for="テンプレート">
      テンプレート
    </LabelText>
    <InputContainer>
      <template #prepend>
        <ChangedBox
          :active="hasMandalaGoalTemplateChanged" />
      </template>
      <BaseSelectWithProvider
        v-if="isEditable"
        :value="form.mandalaGoalTemplate"
        field-class="pl-4"
        name="テンプレート"
        placeholder="テンプレートを選択してください"
        :response-errors="responseErrors"
        rules="required"
        vid="mandalaGoalTemplate"
        col="6"
        :options="publishedMandalaGoalTemplateOptions"
        @input="onInputMandalaGoalTemplate" />
      <DisplayFormFIeld
        v-else
        border
        col="6">
        {{ selectedMandalaGoalTemplate && selectedMandalaGoalTemplate.name }}
      </DisplayFormFIeld>
    </InputContainer>
    <template v-if="selectedMandalaGoalTemplate">
      <div class="d-flex align-items-end justify-content-between">
        <div>
          <div
            v-if="isSubmitted"
            class="d-flex align-items-center">
            <b-badge
              variant="secondary"
              class="fs-m"
              style="border-radius: 0; font-weight: 400;">
              提出済み
            </b-badge>
            <CaptionText class="ml-2">
              {{ mandalaEvaluation.submittedAt | prettyDateTime }}
            </CaptionText>
          </div>
          <LabelText>目標達成に必要な項目と行動目標</LabelText>
        </div>
        <div
          class="my-2">
          <div class="d-flex align-items-center">
            <ChangedBox
              active
              class="mr-1" />
            <CaptionText class="font-weight-bold">
              前月からの変更
            </CaptionText>
          </div>
          <IconTextButton
            class="font-weight-bold"
            active
            :icon-size="30"
            icon="arrow_drop_down"
            @click="scrollToSummary">
            最下部へ
          </IconTextButton>
        </div>
      </div>
      <MandalaEvaluationFormEntryItem
        v-for="(templateEntry, entryIndex) in selectedMandalaGoalTemplate.templateEntries"
        :key="templateEntry.id"
        v-model="form.entries[entryIndex]"
        :display-order="form.entries[entryIndex].displayOrder"
        :index="entryIndex"
        :can-edit="canEdit"
        :is-mine="isMine"
        :last-month-entry="getEntry(lastMonthMandalaEvaluation, entryIndex)"
        :template-entry="templateEntry"
        :selected-mandala-goal-template="selectedMandalaGoalTemplate"
        :response-errors="getEntryResponseErrors(entryIndex)"
        class="mb-2">
        <MandalaEvaluationFormActionGoalItem
          v-for="(num, actionGoalIndex) in selectedMandalaGoalTemplate.actionGoalsCount"
          :key="`actionGoal_${num}`"
          v-model="form.entries[entryIndex].actionGoals[actionGoalIndex]"
          :index="actionGoalIndex"
          :can-edit="canEdit"
          :has-entry-name="!!form.entries[entryIndex].name"
          :selected-mandala-goal-template="selectedMandalaGoalTemplate"
          :template-action-goal="templateEntry.actionGoals[actionGoalIndex]"
          :last-month-action-goal="getActionGoal(lastMonthMandalaEvaluation, entryIndex, actionGoalIndex)"
          :response-errors="getActionGoalResponseErrors(entryIndex, actionGoalIndex)"
          :is-mine="isMine"
          class="mb-2" />
      </MandalaEvaluationFormEntryItem>
      <div ref="summary" />
      <template v-if="canShowSummary">
        <div class="d-flex align-items-center mandala-evaluation-form__summary-label">
          <LabelText
            ref="summary"
            label-for="今月のまとめ"
            class="mb-0">
            {{ month }}月のまとめ
          </LabelText>
          <NoteTemplateDropdownMenu
            v-if="isEditable && noteTemplates.length > 0"
            class="ml-2"
            :note-templates="noteTemplates"
            :selected-id="selectedNoteTemplateId"
            @select="onSelectNoteTemplate" />
        </div>
        <TextareaContainer :disabled="!isEditable">
          <BaseTextareaWithProvider
            v-if="isEditable"
            v-model="form.summary"
            name="今月のまとめ"
            vid="summary"
            :rows="5"
            :disabled="!isEditable"
            :response-errors="responseErrors" />
          <!-- eslint-disable -->
        <DisplayTextarea
          v-else
          v-html="sanitizedLink(form.summary)" />
        <!-- eslint-enable -->
          <template #bottom>
            <div class="d-flex justify-content-end p-1">
              <slot name="like-button" />
            </div>
          </template>
        </TextareaContainer>
        <template v-if="attachmentOption">
          <template v-if="canEdit">
            <LabelText label-for="ファイル">
              ファイルを添付
            </LabelText>
            <FileUploaderWithProvider
              v-model="form.file"
              vid="file"
              name="ファイル"
              :response-errors="responseErrors" />
          </template>
          <template v-else-if="hasFile">
            <LabelText>ファイルを添付</LabelText>
            <FileViewer
              v-if="form.file"
              :file="form.file"
              :thumbnail="form.thumbnail" />
          </template>
        </template>
      </template>
    </template>
    
    <template v-if="isMine && !isSubmitted">
      <BaseButton
        v-if="isMandalaGoalTemplateSelected"
        class="mt-4"
        @click="submit('submitted')">
        提出
      </BaseButton>
    
      <FixedBottomRightArea>
        <IconButton
          v-if="!canEdit"
          data-testid="edit-button"
          icon="edit"
          width="62"
          height="62"
          icon-size="30"
          @click="canEdit = true">
          編集
        </IconButton>
        <BaseButton
          v-else
          data-testid="save-button"
          color="l-blue"
          style="border-radius: 32px;"
          @click="submit('draft')">
          保存
        </BaseButton>
      </FixedBottomRightArea>
    </template>
  </ValidationObserver>
</template>

<script>
import { cloneDeep, omit, uniq } from 'lodash'
import BaseSelectWithProvider from '@/components/parts/BaseSelectWithProvider.vue'
import MandalaEvaluationFormEntryItem from '@/components/view/mandala_evaluation/MandalaEvaluationFormEntryItem.vue'
import MandalaEvaluationFormActionGoalItem from '@/components/view/mandala_evaluation/MandalaEvaluationFormActionGoalItem.vue'
import LabelText from '@/components/parts/LabelText.vue'
import BaseTextareaWithProvider from '@/components/parts/BaseTextareaWithProvider.vue'
import BaseTextFieldWithProvider from '@/components/parts/BaseTextFieldWithProvider.vue'
import BaseButton from '@/components/parts/BaseButton.vue'
import IconButton from '@/components/parts/IconButton.vue'
import FixedBottomRightArea from '@/components/parts/FixedBottomRightArea.vue'
import ChangedBox from '@/components/parts/ChangedBox.vue'
import CaptionText from '@/components/parts/CaptionText.vue'
import IconTextButton from '@/components/parts/IconTextButton.vue'
import InputContainer from '@/components/parts/InputContainer.vue'
import TextareaContainer from '@/components/parts/TextareaContainer.vue'
import DisplayFormFIeld from '@/components/view/mandala_evaluation/DisplayFormField.vue'
import DisplayTextarea from '@/components/view/mandala_evaluation/DisplayTextarea.vue'
import FileUploaderWithProvider from '@/components/parts/FileUploaderWithProvider.vue'
import FileViewer from '@/components/parts/FileViewer.vue'
import NoteTemplateDropdownMenu from '@/components/view/note_templates/NoteTemplateDropdownMenu.vue'
import sanitizedLinkMixin from '@/components/mixin/sanitizedLink'
import { mapGetters, mapState } from 'vuex'
import { format } from 'date-fns'

const getDefaultForm = () => {
  return {
    finalGoal: null,
    targetDate: null,
    mandalaGoalTemplate: null,
    summary: null
  }
}

const getEntriesFromMandalaGoalTemplate = (mandalaGoalTemplate) => {
  const { actionGoalsCount } = mandalaGoalTemplate
  return mandalaGoalTemplate.templateEntries.map(templateEntry => {
    const { name, displayOrder } = templateEntry
    return { name, displayOrder, actionGoals: getEmptyActionGoals(actionGoalsCount) }
  })
}

const getEmptyActionGoals = (count) => {
  return new Array(count).fill(null).map((_, index) => {
    return {
      name: null,
      score: null,
      displayOrder: index,
    }
  })
}

export default {
  components: {
    BaseTextFieldWithProvider,
    BaseSelectWithProvider,
    MandalaEvaluationFormEntryItem,
    MandalaEvaluationFormActionGoalItem,
    LabelText,
    BaseTextareaWithProvider,
    BaseButton,
    IconButton,
    FixedBottomRightArea,
    ChangedBox,
    CaptionText,
    IconTextButton,
    InputContainer,
    TextareaContainer,
    DisplayFormFIeld,
    DisplayTextarea,
    FileUploaderWithProvider,
    FileViewer,
    NoteTemplateDropdownMenu
  },
  mixins: [sanitizedLinkMixin],
  props: {
    mandalaGoalTemplates: {
      type: Array,
      default: () => []
    },
    mandalaEvaluation: {
      type: Object,
      default: null
    },
    lastMonthMandalaEvaluation: {
      type: Object,
      default: null
    },
    // コピー元マンダラ評価
    latestMandalaEvaluation: {
      type: Object,
      default: null
    },
    isMine: {
      type: Boolean,
      default: false
    },
    selectedYearMonth: {
      type: String,
      required: true
    },
    responseErrors: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      form: getDefaultForm(),
      initialForm: getDefaultForm(),
      canEdit: false,
      noteTemplates: [],
      selectedNoteTemplateId: null,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('tenant', ['attachmentOption']),
    ...mapGetters('auth', ['isAnyManager', 'accessibleDepartments']),
    isEditable() {
      return this.isMine && this.canEdit
    },
    publishedMandalaGoalTemplates() {
      return this.mandalaGoalTemplates.filter(template => template.status === 'published')
    },
    mandalaGoalTemplateOptions() {
      return this.mandalaGoalTemplates.map(template => ({ text: template.name, value: template.id }))
    },
    publishedMandalaGoalTemplateOptions() {
      return this.publishedMandalaGoalTemplates.map(template => ({ text: template.name, value: template.id }))
    },
    selectedMandalaGoalTemplate() {
      return this.mandalaGoalTemplates.find(template => this.form.mandalaGoalTemplate === template.id)
    },
    isMandalaGoalTemplateSelected() {
      return this.selectedMandalaGoalTemplate != null
    },
    isEdit() {
      return this.mandalaEvaluation !== null
    },
    isSubmitted() {
      return this.mandalaEvaluation?.status === 'submitted'
    },
    // 閲覧可能なグループに所属グループが含まれていない場合があり、
    // そのままでは所属グループ限定のテンプレートが取得できないため必ず足す
    noteTemplateDepartmentIds() {
      const accessibleIds = this.accessibleDepartments.map(department => department.id)
      const ownId = this.user?.department?.id
      return uniq(ownId ? [ownId, ...accessibleIds] : accessibleIds)
    },
    canShowSummary() {
      if (!this.selectedMandalaGoalTemplate) {
        return false
      }
      return this.isMine || this.isAnyManager || !this.selectedMandalaGoalTemplate.isLockSummary
    },
    hasFinalGoalChanged() {
      if (!this.lastMonthMandalaEvaluation) {
        return false
      }
      return (this.lastMonthMandalaEvaluation.finalGoal || '') !== (this.form.finalGoal || '')
    },
    hasMandalaGoalTemplateChanged() {
      if (!this.lastMonthMandalaEvaluation) {
        return false
      }
      return this.lastMonthMandalaEvaluation.mandalaGoalTemplate !== this.form.mandalaGoalTemplate
    },
    isMandalaGoalTemplateChanged() {
      return this.form.mandalaGoalTemplate !== this.initialForm.mandalaGoalTemplate
    },
    month() {
      return format(new Date(this.selectedYearMonth), 'M')
    },
    hasFile() {
      return !!this.form.file
    },
  },
  watch: {
    canEdit(v) {
      if (v) {
        const isTemplatePublished = this.publishedMandalaGoalTemplates.find(template => template.id === this.form.mandalaGoalTemplate)
        if (!isTemplatePublished) {
          this.form.mandalaGoalTemplate = null
        }
      }
    }
  },
  created() {
    this.initForm()
    this.fetchNoteTemplates()
  },
  methods: {
    fetchNoteTemplates() {
      // メンバーは所属グループが参照できるものが返るためパラメータ不要
      // 管理者・限定指導者はパラメータ無しだとテナント全件が返るため、閲覧可能なグループを指定する
      // ページングで取りこぼさないよう全件を一度に取得する
      const params = this.isAnyManager
        ? { limit: 99999, department__in: this.noteTemplateDepartmentIds.join(',') }
        : { limit: 99999 }
      return this.$axios.get('/note_templates/', { params })
        .then(res => {
          this.noteTemplates = res.data.results
        })
        .catch(e => {
          // テンプレートが取得できなくてもまとめの入力は継続できるため、エラーは通知しない
          console.error(e)
        })
    },
    onSelectNoteTemplate(noteTemplate) {
      // 月のまとめには活動名にあたる項目がないため、活動記録の本文だけを差し込む
      const hasInput = !!this.form.summary
      if (hasInput && !window.confirm('テンプレートを選択すると現在記録中の内容が消えます。よろしいですか？')) return

      this.form.summary = noteTemplate.detail
      this.selectedNoteTemplateId = noteTemplate.id
    },
    /**
     * @description 親コンポーネントからcanEditを操作するためのmethod
     */
    setCanEdit(bool) {
      this.canEdit = bool
    },
    initForm() {
      if (this.isEdit) {
        // 編集時のformの初期化処理
        const mandalaEvaluation = this.mandalaEvaluation
        this.form = this.getFormFromEvaluation(mandalaEvaluation)
        this.initialForm = cloneDeep(this.form)
      } else {
        // 新規登録時のformの初期化処理
        if (this.isMine) {
          this.canEdit = true
        }
        const latestMandalaEvaluation = this.latestMandalaEvaluation
        if (!latestMandalaEvaluation) {
          return
        }
        this.form = this.getDefaultFormFromLatestEvaluation(latestMandalaEvaluation)
        this.initialForm = cloneDeep(this.form)
      }
    },
    getFormFromEvaluation(mandalaEvaluation) {
      // form上で不要なプロパティを削除
      const newForm = omit(mandalaEvaluation, ['id', 'createdAt', 'updatedAt', 'submittedAt', 'mandalaGoalSelfEvaluationEntries'])
      newForm.entries = mandalaEvaluation.mandalaGoalSelfEvaluationEntries.map(entry => {
        return {
          ...entry,
          actionGoals: entry.mandalaGoalSelfEvaluationActionGoals
        }
      })
      return newForm
    },
    getDefaultFormFromLatestEvaluation(mandalaEvaluation) {
      // form上で不要なプロパティを削除
      const newForm = omit(mandalaEvaluation, ['id', 'createdAt', 'updatedAt', 'submittedAt', 'mandalaGoalSelfEvaluationEntries'])
      // リセットが必要なプロパティをリセット
      newForm.file = null
      newForm.summary = null
      const isTemplatePublished = this.publishedMandalaGoalTemplates.find(template => template.id === newForm.mandalaGoalTemplate)
      if (!isTemplatePublished) {
        newForm.mandalaGoalTemplate = null
      }
      newForm.entries = mandalaEvaluation.mandalaGoalSelfEvaluationEntries.map(entry => {
        return {
          ...entry,
          activityRecord: null,
          file: null,
          actionGoals: entry.mandalaGoalSelfEvaluationActionGoals.map(actionGoal => {
            return {
              ...actionGoal,
              score: null
            }
          })
        }
      })
      return newForm
    },
    async submit(status) {
      this.canEdit = true
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$store.commit('notify/set', { message: '入力内容に不備があります。ご確認の上再度実行してください。', type: 'danger' })
        return
      }
      if (status === 'submitted') {
        if (!window.confirm(`${this.month}月の自己評価を提出します。提出後に内容を変更する場合は、指導者に「差し戻し」を依頼してください。提出しますか？`)) return
      }
      this.$emit('submit', { status, formData: this.generateFormData(status) })
    },
    onInputMandalaGoalTemplate(selectedTemplateId) {
      if (this.form.mandalaGoalTemplate) {
        if (!window.confirm('テンプレートを変更すると新たに「項目」「行動目標」の入力が必要です。変更しますか？')) return
      }
      const selectedMandalaGoalTemplate = this.mandalaGoalTemplates.find(template => template.id === selectedTemplateId)
      const newForm = { ...this.form, mandalaGoalTemplate: selectedTemplateId, entries: getEntriesFromMandalaGoalTemplate(selectedMandalaGoalTemplate) }
      this.form = newForm
    },
    getEntry(mandalaEvaluation, index) {
      return mandalaEvaluation?.mandalaGoalSelfEvaluationEntries[index]
    },
    getActionGoal(mandalaEvaluation, entryIndex, actionGoalIndex) {
      return mandalaEvaluation?.mandalaGoalSelfEvaluationEntries[entryIndex]?.mandalaGoalSelfEvaluationActionGoals[actionGoalIndex]
    },
    getEntryResponseErrors(index) {
      return this.responseErrors.mandalaGoalSelfEvaluationEntries?.[index]
    },
    getActionGoalResponseErrors(entryIndex, actionGoalIndex) {
      return this.getEntryResponseErrors(entryIndex)?.mandalaGoalSelfEvaluationActionGoals?.[actionGoalIndex]
    },
    generateFormData(status) {
      const formData = new FormData()
      formData.append('year_month', this.selectedYearMonth)
      formData.append('final_goal', this.form.finalGoal)
      formData.append('target_date', this.form.targetDate)
      formData.append('mandala_goal_template', this.form.mandalaGoalTemplate)
      formData.append('summary', this.form.summary || '')
      if (this.form.file instanceof File) {
        formData.append('file', this.form.file)
      } else if (this.form.file == null) {
        formData.append('file', '')
      }
      formData.append('status', status)
      this.form.entries.forEach(entry => {
        formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]name`, entry.name || '')
        if (entry.file instanceof File) {
          formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]file`, entry.file)
        } else if (entry.file === null) {
          formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]file`, '')
        }
        formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]activity_record`, entry.activityRecord || '')
        // 作成の場合はdisplayOrder、編集の場合はテンプレートが変わっていなければidで識別させ、テンプレートが変わっている場合はdisplayOrderで識別させる
        if (this.isEdit && !this.isMandalaGoalTemplateChanged) {
          formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]id`, entry.id)
        } else {
          formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]display_order`, entry.displayOrder)
        }
        
        entry.actionGoals.forEach(actionGoal => {
          formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]mandala_goal_self_evaluation_action_goals[${actionGoal.displayOrder}]name`, actionGoal.name || '')
          if (actionGoal.score == null) {
            formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]mandala_goal_self_evaluation_action_goals[${actionGoal.displayOrder}]score`, '')
          } else {
            formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]mandala_goal_self_evaluation_action_goals[${actionGoal.displayOrder}]score`, actionGoal.score)
          }
          if (this.isEdit && !this.isMandalaGoalTemplateChanged) {
            formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]mandala_goal_self_evaluation_action_goals[${actionGoal.displayOrder}]id`, actionGoal.id)
          } else {
            formData.append(`mandala_goal_self_evaluation_entries[${entry.displayOrder}]mandala_goal_self_evaluation_action_goals[${actionGoal.displayOrder}]display_order`, actionGoal.displayOrder)
          }
          
        })
      })
      return formData
    },
    scrollToEl(el) {
      const rect = el.getBoundingClientRect()
      const elementTop = rect.top + window.pageYOffset
      const offset = 50
      window.scrollTo(0, elementTop - offset)
    },
    scrollToSummary() {
      this.$nextTick(() => {
        const el = this.$refs.summary.$el
        if (el) {
          this.scrollToEl(el)
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.mandala-evaluation-form__summary-label {
  margin-top: 24px;
}
</style>